<mat-dialog-content>
  <p class="portal-warning">You've gone idle. You will be logged out shortly.</p>
</mat-dialog-content>
